<template>
  <div class="index-main">
    <Header/>

    <div>
      <div class="section-box register-info-box">
        <div>
          <div class="section-img">
            <img data-id="1" class="active" src="@/assets/loginBg.png" alt=""/>
            <img class="section-bg" src="@/assets/loginBg.png" alt=""/>
          </div>
          <div class="section-info register-info">
            <div class="register-title">忘记密码</div>
            <div class="login-box register-box">
              <div class="active">
                <label id="mobile-box" class="info-label" for="mobile">
                  <label id="global_box" for="global_roaming">
                    <select id="global_roaming">
                      <option selected value="86">+86</option>
                    </select>
                    <i></i>
                  </label>
                  <input
                    id="mobile"
                    v-model="tel"
                    type="text"
                    maxlength="11"
                    placeholder="请输入手机号"
                  />
                </label>
                <label id="vCode-box" class="info-label" for="vCode">
                  <i
                    class="iconfont icon-xinxiduanxinxiaoxitixingyoujiansixinyouxiang"
                  ></i>
                  <input
                    id="vCode"
                    type="text"
                    v-model="codeVal"
                    maxlength="4"
                    placeholder="短信验证码"
                  />
                  <div
                    id="getCode"
                    class="vCode-btn vCode-show"
                    :class="disabled ? 'disabled' : ''"
                    @click="getCode"
                  >
                    {{ btntxt }}
                  </div>
                  <!-- <div @click="getCode()" class="vCode-btn vCode-show">
                    {{ codeTime == 60 || codeTime == 0 ? getCodeText : codeTime }}
                  </div> -->
                </label>
                <label id="password-box" class="info-label" for="password">
                  <i class="iconfont icon-mima"></i>
                  <input
                    id="password"
                    v-model="password_new"
                    :type="eyeA_status ? 'password' : 'text'"
                    maxlength="20"
                    placeholder="设置新密码（6-20位数字和字母组合）"
                  />
                </label>
                <label id="password2-box" class="info-label" for="password2">
                  <i class="iconfont icon-mima"></i>
                  <input
                    id="password2"
                    v-model="password_news"
                    :type="eyeB_status ? 'password' : 'text'"
                    maxlength="20"
                    placeholder="请再次输入新密码"
                  />
                </label>
                <div class="login-submit" id="register" @click="retrievePassword">
                  重置密码
                </div>
                <div class="other">
                  <label class="agreement-box" for="user-agreement">
                    <input id="user-agreement" ref="checkInput" type="checkbox"/>
                    <div>
                      同意<a href="/article/user_agreement" target="_blank"
                    >《用户协议》</a
                    >与<a href="/article/privacy_policy" target="_blank"
                    >《隐私政策》</a
                    >
                    </div>
                  </label>
                  <div><a href="/login">去登录</a></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>
<script>
import Header from "@/globalComponents/Header";
import Footer from "@/globalComponents/Footer";
import userApi from '@/api/user';
import appApi from '@/api/app';
export default {
  data() {
    return {
      tel: "",
      password_new: "",
      password_news: "",
      eyeB_status: 1,
      codeVal: "",
      check: false,
      eyeA_status: 1,
      disabled: false,
      time: 60,
      btntxt: "发送验证码",
      email: ""
    };
  },
  methods: {
    async retrievePassword() {
      this.check = this.$refs.checkInput.checked;
      let data = {
        mobile: this.tel,
        password: this.password_new,
        repassword: this.password_news,
        captcha: this.codeVal,
        email: this.email
      };
      if (!this.check) {
        this.$message.error("请先同意用户协议");
        return;
      }

      if (!data.mobile || !data.password || !data.repassword || !data.captcha) {
        this.$message.error("请正确填写信息");
        return;
      }

      await userApi.resetPassword({
        mobile: this.tel,
        password: this.password_new,
        code: this.codeVal,
      })
      this.$message({
        message: "密码重置成功",
        type: "success"
      });
      setTimeout(res => {
        this.$router.push({
          path: "/login"
        });
      }, 2000);
    },
    // 获取验证码
    async getCode() {
      if (this.disabled) {
        return;
      }
      if (this.ToastText == "") {
        this.$message({
          message: "内容不能为空",
          type: "warning"
        });
        return;
      }

      await appApi.sendSms({
        mobile: this.tel,
        template_code: "user_password_modify",
      })

      this.sendcode();
    },
    sendcode() {
      this.time = 60;
      this.timer();
    },
    //发送手机验证码倒计时
    timer() {
      if (this.time > 0) {
        this.disabled = true;
        this.time--;
        this.btntxt = this.time + "秒";
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.btntxt = "发送验证码";
        this.disabled = false;
      }
    }
  },
  components: {
    Header,
    Footer
  }
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>
